// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnglishFormActionSection_formSubmitContainer__iU1Jo {
  margin-bottom: 20px !important;
  display: flex !important;
  justify-content: flex-end !important;
  padding: 50px 15px 15px 15px !important;
  column-gap: 24px;
}
.EnglishFormActionSection_submitBtn__Uvsr0 {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  color: #fafafa;
  cursor: pointer;
  background-color: #3963b8;
  border: none;
  font-weight: 500;
  font-size: 16px;
}
.EnglishFormActionSection_cancelBtn__V4NnU {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  cursor: pointer;
  color: #787878;
  border: 1px solid #787878;
  background-color: #fff;
  font-weight: 500;
  font-size: 16px;
}
.EnglishFormActionSection_deleteBtn__UOA4A {
  width: 100px;
  height: 38px;
  border-radius: 5px;
  cursor: pointer;
  color: #cc3232;
  border: 1px solid #cc3232;
  background-color: #fff;
  font-weight: 500;
  font-size: 16px;
}
@media all and (max-width: 600px) {
  .EnglishFormActionSection_submitBtn__Uvsr0,
  .EnglishFormActionSection_cancelBtn__V4NnU,
  .EnglishFormActionSection_deleteBtn__UOA4A {
    font-weight: 400;
    font-size: 14px;
    width: 80px;
    height: 30px;
  }
}
@media all and (max-width: 350px) {
  .EnglishFormActionSection_formSubmitContainer__iU1Jo {
    padding: 25px 5px 20px 5px !important;
    column-gap: 12px;
  }
  .EnglishFormActionSection_submitBtn__Uvsr0,
  .EnglishFormActionSection_cancelBtn__V4NnU,
  .EnglishFormActionSection_deleteBtn__UOA4A {
    font-weight: 400;
    font-size: 12px;
    width: 70px;
    height: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/EnglishFormActionSection/EnglishFormActionSection.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;;;IAGE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,qCAAqC;IACrC,gBAAgB;EAClB;EACA;;;IAGE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".formSubmitContainer {\r\n  margin-bottom: 20px !important;\r\n  display: flex !important;\r\n  justify-content: flex-end !important;\r\n  padding: 50px 15px 15px 15px !important;\r\n  column-gap: 24px;\r\n}\r\n.submitBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  color: #fafafa;\r\n  cursor: pointer;\r\n  background-color: #3963b8;\r\n  border: none;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n.cancelBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  color: #787878;\r\n  border: 1px solid #787878;\r\n  background-color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n.deleteBtn {\r\n  width: 100px;\r\n  height: 38px;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  color: #cc3232;\r\n  border: 1px solid #cc3232;\r\n  background-color: #fff;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n@media all and (max-width: 600px) {\r\n  .submitBtn,\r\n  .cancelBtn,\r\n  .deleteBtn {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    width: 80px;\r\n    height: 30px;\r\n  }\r\n}\r\n@media all and (max-width: 350px) {\r\n  .formSubmitContainer {\r\n    padding: 25px 5px 20px 5px !important;\r\n    column-gap: 12px;\r\n  }\r\n  .submitBtn,\r\n  .cancelBtn,\r\n  .deleteBtn {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    width: 70px;\r\n    height: 25px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSubmitContainer": `EnglishFormActionSection_formSubmitContainer__iU1Jo`,
	"submitBtn": `EnglishFormActionSection_submitBtn__Uvsr0`,
	"cancelBtn": `EnglishFormActionSection_cancelBtn__V4NnU`,
	"deleteBtn": `EnglishFormActionSection_deleteBtn__UOA4A`
};
export default ___CSS_LOADER_EXPORT___;
